'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Space = require('../../Space/src/Space.js');
var ControlGroup_module = require('../styles/ControlGroup.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description ControlGroup component.
 *
 * @component
 * @example
 * ```jsx
 * <ControlGroup>
 *  <TextInput placeholder="Left input position"/>
 *  <TextInput placeholder="Center input position"/>
 *  <TextInput placeholder="Right input position"/>
 * </ControlGroup>
 * ```
 */
const ControlGroup = React__namespace.forwardRef((props, ref) => {
    const { className, children, direction, ...restProps } = props;
    const cx = reactUtils.useStyles(ControlGroup_module.default);
    const count = React__namespace.useMemo(() => React__namespace.Children.count(children), [children]);
    const condition = count < 2;
    // Ensure group has more than one child node
    if (condition) {
        reactUtils.error({
            condition,
            message: 'Ensure group has more than one child node',
        })();
    }
    const group = React__namespace.useMemo(() => React__namespace.Children.map(children, (child, index) => {
        if (child == null) {
            return;
        }
        if (condition) {
            return child;
        }
        let positionInGroup = '';
        if (index === 0) {
            positionInGroup = 'start';
        }
        else if (index === count - 1) {
            positionInGroup = 'end';
        }
        else {
            positionInGroup = 'middle';
        }
        return React__namespace.cloneElement(child, { ...child.props, positionInGroup, directionGroup: direction });
    }), [children, condition, count, direction]);
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "ControlGroup", className: cx(className, 'container'), ...restProps },
        React__namespace.createElement(Space.Space, { direction: direction, size: 2 }, group)));
});
ControlGroup.defaultProps = {
    direction: 'horizontal',
};
ControlGroup.displayName = 'ControlGroup';

exports.ControlGroup = ControlGroup;
//# sourceMappingURL=ControlGroup.js.map
